import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import ErrorIcon from '../../../../../assets/images/icon_error_messages.gif';
import { FormBox } from '../../../css';

const InputField = ({
  label,
  type,
  errors,
  touched,
  name,
  placeholder,
  readOnly,
  setFieldValue
}) => {
  return (
    <FormBox>
      <div className="main-content-form-headers">
        <span>{label}</span>
      </div>
      <div
        style={{ position: 'relative' }}
        className={`input-container ${errors[name] && touched[name] ? 'error' : ''
          }`}
      >
        <Field
          name={name}
          type={type}
          className="select-style"
          placeholder={placeholder}
          readOnly={readOnly}
          onChange={e => {
            setFieldValue(e.target.value);
          }}
        />

        <>
          <div className="error_messages">
            <span className="registration-error">{errors[name]}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </FormBox>
  );
};

InputField.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  errors: PropTypes.objectOf(PropTypes.string),
  touched: PropTypes.objectOf(PropTypes.bool),
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired
};

InputField.defaultProps = {
  errors: {},
  touched: {},
  type: 'text',
  placeholder: '',
  readOnly: false
};

export default InputField;
